import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Toast.css';

const Toast = ({ message, type = 'info', onClose, duration = 3000 }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div className={`toast toast-${type}`} role="alert" aria-live="polite">
      <div className="toast-content">
        <span className="toast-message">{message}</span>
        <button
          className="toast-close"
          onClick={onClose}
          aria-label={t('ui.closeNotification')}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;

